import React from 'react';

import { Popover } from '@primer/react'

import {
  formatRelative, parseISO
} from 'date-fns'
import PipelineStatusBadge from './PipelineStatusBadge';

export const PipelineStatusWithPopover = ({ data, status, textColor = 'text-white' }) => {
  const [hover, setHover] = React.useState(false);
  const ret = data;
  const deployment = ret?.original?.latestVersion?.deployments?.[0];
  const deployedAt = deployment?.updatedAt;
  const deployed = deployment?.deployed ?? false;

  return <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} style={{ position: 'relative' }}>
    {/* Positioning is calculated from the size of the IconButton in PipelineStatusBadge */}
    <Popover open={hover} caret="top-left" sx={{
      top: '40px',
      left: '60px'
    }}>
      <Popover.Content>
        {deployed
          ? <p>Deployed {formatRelative(parseISO(deployedAt), Date.now())}</p>
          : deployedAt
            ? <p>Stopped {formatRelative(parseISO(deployedAt), Date.now())} </p>
            : <p>Never deployed.</p>
        }
      </Popover.Content>
    </Popover>
    <PipelineStatusBadge status={status} textColor={textColor} />
  </div>;
}

export default PipelineStatusWithPopover;
